import React, { useEffect, useState, useRef } from "react";

import { useNavigate } from "react-router";
import { Row, Container, Col, Button, Tabs, Tab } from "react-bootstrap";
import { EmptyCard, Line, Total, LabelText, CartLayout, SummaryCard, PageWrap } from "./styles";
import notify from "../../components/UI/toast";
import { FormatCurrency, FormatPoints } from "../../lib";
import { LoaderSmall } from "../../components/Loader";
import { useUserData } from "../../hooks/UserContext";
import ErrorBoundary from "../../components/ErrorBoundary";
import Footer from "../../components/Footer";
import Title from "../../components/Title";
import ListTabContent from "./ListTabContent";
import { useSelector, useDispatch } from "react-redux";
import { getCart } from "../../Redux/cartSlice";
import { useApp } from "../../contexts/AppContext";
import {
  trackViewCartMarketplaceItems,
  trackClick,
} from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../hooks/useScreenTracking";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function OrderResume() {
  const navigate = useNavigate();
  const screenName = useScreenTracking();
  const isDesktop = useMediaQuery("(min-width:1024px)");

  const [tab, setTab] = useState("dinheiro");
  const { whitelabel } = useApp();
  const [displayMode, setDisplayMode] = useState(
    whitelabel?.config?.payment_mode,
  );

  useEffect(() => {
    setDisplayMode(whitelabel?.config?.payment_mode);
  }, [whitelabel]);

  const { user, addressShipping, cartItemsError } = useUserData();

  const dispatch = useDispatch();

  const { cart, loading } = useSelector((state) => state.cartSlice);
  const viewCartSent = useRef(false);

  useEffect(() => {
    if (user?.uuid) {
      const cep =
        addressShipping?.cep ||
        (user?.addresses?.length ? user.addresses[0].cep : undefined);
      if (cep) {
        dispatch(getCart({ uuid: user.uuid, cep, force: true }));
      }
    }
  }, [user?.uuid, addressShipping?.cep, user?.addresses, dispatch]);

  useEffect(() => {
    if (loading || viewCartSent.current) return;
    const items = cart?.items || [];
    if (!items.length) return;
    trackViewCartMarketplaceItems(items);
    viewCartSent.current = true;
  }, [loading, cart?.items]);

  const sendOrderResumeAnalytics = (customTitle) => {
    trackClick({
      title: customTitle,
      contentType: "checkout",
      screenName,
      tagId: tagIdFromLegacySuffix("15"),
    });
  };

  const handleCheckout = () => {
    // if (cart.warning) {
    //   return;
    // }
    if (disable()) {
      return;
    }

    if (!Object.keys(addressShipping).length) {
      notify("Selecione o endereço de entrega!", "error");
      return;
    }
    sendOrderResumeAnalytics("ir-para-o-resumo");

    navigate("/loja/ordersummary/");
  };

  const totalPoints = () => {
    let total = 0;

    cart.items.forEach((item) => {
      total += item.price.points.offer * item.quantity;
    });

    Object.keys(cart.shipping_by_brand).forEach((brandUuid) => {
      total += cart.shipping_by_brand[brandUuid].shipping_point;
    });

    return total;
  };

  const disable = () => {
    if (
      cart?.minimum_payments &&
      cart?.minimum_payments?.TIM &&
      tab === "pontos"
    ) {
      if (cart.minimum_payments.TIM > user.balance) {
        return true;
      }
    }
    return false;
  };

  if (loading) return <LoaderSmall />;

  const renderTotal = () => (
    <>
      {displayMode === "money" && (
        <Total className="text-mg  font-wl-700 text-base my-1">
          {FormatCurrency(cart.summary.total)}
        </Total>
      )}
      {displayMode === "points" && (
        <Total className="text-mg font-wl-700 text-base my-1">
          {FormatPoints(totalPoints())} pts
        </Total>
      )}
      {displayMode === "both" && (
        <>
          <Total className="text-mg font-wl-700 text-base color-text-dark my-1">
            {FormatCurrency(cart.summary.total)}
          </Total>
          <Total className="text-mg font-wl-700 text-base color-text-dark my-1">
            Ou {FormatPoints(totalPoints())} pts
          </Total>
        </>
      )}
    </>
  );

  const cartActions = (
    <>
      <Button
        type="button"
        className={`btn-default-wl text-xs ${
          cart.warning || (disable() && "disable")
        }`}
        disabled={!cart.items.length || (cartItemsError && cartItemsError.item)}
        onClick={() => handleCheckout()}
      >
        IR PARA O RESUMO
      </Button>
      <Button
        type="button"
        className={`btn-outline-wl text-xs ${
          cart.warning || (disable() && "disable")
        }`}
        onClick={() => {
          sendOrderResumeAnalytics("continuar-comprando");
          navigate("/loja");
        }}
      >
        CONTINUAR COMPRANDO
      </Button>
    </>
  );

  return (
    <>
      <ErrorBoundary>
        <div className="wl-page mt-4">
          <PageWrap>
          <Container>
            <Title label="Carrinho da compra" />
            <div className="w-full mt-5">
              {cart?.items?.length > 0 ? (
                <CartLayout>
                  <div className="cart-list">
                    <Tabs
                      id="controlled-tab-cart"
                      activeKey={tab}
                      onSelect={(k) => setTab(k)}
                      variant="pills"
                      className="skills-tabs mt-4 d-none"
                    >
                      <Tab
                        tabClassName="skills-tab"
                        eventKey="dinheiro"
                        title="Dinheiro"
                      >
                        <ListTabContent
                          items={cart?.items}
                          tab={tab}
                          warning={cart?.warning}
                          shippingByBrandData={cart.shipping_by_brand}
                          displayMode={displayMode}
                        />
                      </Tab>
                    </Tabs>
                  </div>

                  <div className="cart-summary">
                    <SummaryCard>
                      <Row className="pt-3 mb-4">
                        <Col>
                          <Total className="text-mg text-base font-wl-700 m-0">
                            Total do Pedido
                          </Total>
                        </Col>
                        <Col className="text-end">{renderTotal()}</Col>
                      </Row>
                      {isDesktop && (
                        <div className="cart-actions">{cartActions}</div>
                      )}
                    </SummaryCard>
                  </div>
                </CartLayout>
              ) : (
                <EmptyCard className="mx-4">
                  <LabelText className="font-wl-500 text-center">
                    Você ainda não adicionou produtos a sua sacola.
                  </LabelText>
                  <div
                    id="goHomeButton"
                    className="d-flex align-items-center justify-content-center"
                  >
                    <Button
                      type="button"
                      className="btn-default-wl text-xxs"
                      style={{ width: 180, heigh: 30 }}
                      onClick={() => navigate("/loja")}
                    >
                      IR PARA HOME
                    </Button>
                  </div>
                  <Line />
                  <Row className="pt-3 mb-4">
                    <Col>
                      <Total className="text-base font-wl-700 color-text-dark m-0">
                        Total do Pedido
                      </Total>
                    </Col>
                    <Col className="text-end">
                      {displayMode === "money" && (
                        <Total className="text-mg  font-wl-700 text-base my-1">
                          {FormatCurrency("0")}
                        </Total>
                      )}
                      {displayMode === "points" && (
                        <Total className="text-mg font-wl-700 text-base my-1">
                          {FormatPoints(0)} pts
                        </Total>
                      )}
                      {displayMode === "both" && (
                        <>
                          <Total className="text-mg font-wl-700 text-base color-text-dark my-1">
                            {FormatCurrency("0")}
                          </Total>
                          <Total className="text-mg font-wl-700 text-base color-text-dark my-1">
                            Ou {FormatPoints(0)} pts
                          </Total>
                        </>
                      )}
                    </Col>
                  </Row>
                </EmptyCard>
              )}
            </div>
          </Container>
          </PageWrap>
        </div>
        {!isDesktop && (
          <Footer orderResume={true}>{cartActions}</Footer>
        )}
      </ErrorBoundary>
    </>
  );
}
